(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-carousel"] && !Shopify.designMode) return;
  try {
    class VideoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[ref="track"]');
      this.dialog = this.querySelector('[data-carousel-dialog]');
      this.dialogContent = this.querySelector('[data-carousel-dialog-content]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');

      this.addEventListener('click', this.handleClick.bind(this));
      this.dialog.addEventListener('click', this.handleDialogClick.bind(this));
      this.dialog.addEventListener('close', this.handleDialogClose.bind(this));

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByAmount(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByAmount(1));
    }

    handleClick(event) {
      if (event.target.closest('[data-carousel-close]')) {
        this.closeDialog();
        return;
      }

      const item = event.target.closest('.video-carousel__item');
      if (item) {
        event.preventDefault();
        this.openItem(item);
      }
    }

    openItem(item) {
      const template = item.querySelector('template');
      if (!template) return;

      this.dialogContent.innerHTML = '';
      this.dialogContent.appendChild(template.content.cloneNode(true));
      this.dialog.showModal();

      const video = this.dialogContent.querySelector('video');
      if (video) {
        video.muted = false;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            // Se o navegador bloquear o autoplay com som por algum motivo,
            // o usuário ainda pode dar play manualmente nos controles nativos.
          });
        }
      }
    }

    handleDialogClick(event) {
      if (event.target === this.dialog) {
        this.closeDialog();
      }
    }

    handleDialogClose() {
      const video = this.dialogContent.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      this.dialogContent.innerHTML = '';
    }

    closeDialog() {
      if (this.dialog.open) this.dialog.close();
    }

    scrollByAmount(direction) {
      const itemWidth = this.track.querySelector('.video-carousel__item')?.offsetWidth || 110;
      this.track.scrollBy({ left: direction * (itemWidth + 12), behavior: 'smooth' });
    }
  }

  if (!customElements.get('video-carousel')) {
    customElements.define('video-carousel', VideoCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
